export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20beautifully%20arranged%20boutique%20fashion%20boutique%20display%20with%20sneakers%20hoodies%20denim%20jackets%20watches%20and%20leather%20bags%20organized%20in%20geometric%20grid%20pattern%20on%20warm%20terracotta%20tile%20floor%2C%20soft%20natural%20light%20creating%20long%20shadows%2C%20editorial%20fashion%20photography%20with%20warm%20earth%20tone%20palette%20and%20artistic%20composition&width=1800&height=1000&seq=hero-bg-2026-kakobuy-unique&orientation=landscape"
          alt="Kakobuy Spreadsheet - modne produkty i akcesoria"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/45 via-foreground-900/30 to-foreground-900/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-white/90 text-xs font-medium tracking-wider uppercase mb-6">
            Kakobuy Spreadsheet Polska
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Znajdź najlepsze produkty
            <br />
            <span className="italic font-normal">szybciej i prościej</span>
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
            Kompletne arkusze produktów, aktualne listy finds oraz praktyczne przewodniki pomagające odkrywać najlepsze okazje w jednym miejscu.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white text-foreground-900 hover:bg-background-100 transition-all duration-200 cursor-pointer text-sm font-semibold whitespace-nowrap"
            >
              Sprawdź Kakobuy Spreadsheet
            </a>
            <a
              href="#kategorie"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/40 text-white hover:bg-white/10 transition-all duration-200 cursor-pointer text-sm font-semibold whitespace-nowrap"
            >
              Zobacz kategorie
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {['Aktualizowane listy', 'Porównania platform', 'Bezpieczne źródła', 'Darmowe przewodniki'].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-white/70 text-xs">
                <i className="ri-check-line text-accent-400 text-sm"></i>
                <span>{badge}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}